import * as React from 'react';
import Pagination from '@mui/material/Pagination';
import type { TablePaginationActionsProps } from '@mui/material/TablePagination/TablePaginationActions';
import { GridPagination } from '@mui/x-data-grid-pro';

const DataGridPaginationActions = ({
  count,
  page,
  rowsPerPage,
  onPageChange,
}: TablePaginationActionsProps) => {
  const pageCount = Math.max(1, Math.ceil(count / rowsPerPage));

  return (
    <Pagination
      color="primary"
      shape="rounded"
      size="small"
      count={pageCount}
      page={page + 1}
      disabled={count === 0}
      showFirstButton
      showLastButton
      onChange={(_, nextPage) => onPageChange(null, nextPage - 1)}
    />
  );
};

export default function DataGridPagination() {
  return (
    <GridPagination
      ActionsComponent={DataGridPaginationActions}
      labelRowsPerPage="Rows per page:"
      sx={{
        flexGrow: 1,
        '& .MuiTablePagination-toolbar': {
          minHeight: 52,
          flexWrap: 'wrap',
          justifyContent: 'flex-end',
          rowGap: 1,
        },
        '& .MuiTablePagination-spacer': {
          display: 'none',
        },
        '& .MuiTablePagination-actions': {
          ml: 1,
        },
      }}
    />
  );
}
